import { useState } from 'react';

export const useSlideout = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [title, setTitle] = useState('');
  const [content, setContent] = useState(null);
  const [width, setWidth] = useState('600px');
  const [customOnClose, setCustomOnClose] = useState(null);

  const openSlideout = (slideoutTitle, slideoutContent, slideoutWidth = '600px', onClose = null) => {
    setTitle(slideoutTitle);
    setContent(slideoutContent);
    setWidth(slideoutWidth);
    setCustomOnClose(() => onClose);
    setIsOpen(true);
  };

  const closeSlideout = () => {
    setIsOpen(false);
    setTimeout(() => {
      setTitle('');
      setContent(null);
      setCustomOnClose(null);
    }, 300); // Wait for animation to complete
  };

  const handleClose = () => {
    if (customOnClose) {
      customOnClose();
    } else {
      closeSlideout();
    }
  };

  return {
    isOpen,
    title,
    content,
    width,
    openSlideout,
    closeSlideout,
    handleClose
  };
};